import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { BaseTableRoot } from './BaseTable.styled';
import { DEFAULT_BASE_TABLE_BORDER_TYPE, DEFAULT_BASE_TABLE_FULL_WIDTH, DEFAULT_BASE_TABLE_MODE, DEFAULT_BASE_TABLE_ZEBRA } from './BaseTable.constants';
// Component.
// -----------------------------------------------------------------------------
const BaseTable = forwardRef(({ borderType = DEFAULT_BASE_TABLE_BORDER_TYPE, children, fullWidth = DEFAULT_BASE_TABLE_FULL_WIDTH, mode = DEFAULT_BASE_TABLE_MODE, zebra = DEFAULT_BASE_TABLE_ZEBRA, ...rest }, ref) => (_jsx(BaseTableRoot, { borderType: borderType, fullWidth: fullWidth, mode: mode, ref: ref, zebra: zebra, ...rest, children: children })));
// Component configuration.
// -----------------------------------------------------------------------------
BaseTable.displayName = 'BaseTable';
export default BaseTable;
//# sourceMappingURL=BaseTable.js.map